import { getRequest } from '@helpers/api';

import type { AggregateTypeApi, EcslAggregatesApiResult, EcslAggregateTotalsApi } from './types';

// TODO: Update unknown Promise returns from the rest of the api calls to their respective types.

/**
 * Fetch list of running aggregate jobs
 */
export const checkStandardTemplateAggregateJobsRunning = (
  standardTemplateId: string
): Promise<unknown> =>
  getRequest(`vFile/standardTemplateIsAggregateJobRunning/${standardTemplateId}/`);

/**
 * Fetch aggregates for Italy
 */
export const getAggregatesItaly = (standardTemplateId: string): Promise<unknown> =>
  getRequest(`vFile/standardTemplateAggregateItalyVAT/${standardTemplateId}/`);

/**
 * Fetch aggregates
 * @param {string} standardTemplateId Standard template ID to check
 */
export const getAggregates = (standardTemplateId: string): Promise<unknown> =>
  getRequest(`vFile/standardTemplateAggregate/${standardTemplateId}/`);

/**
 * Fetch ECSL/ECPL aggregates
 */
export const getAggregatesECSL = ({
  standardTemplateId,
  type,
  limit,
  offset,
}: {
  standardTemplateId: string;
  type: AggregateTypeApi;
  limit?: number;
  offset?: number;
}): Promise<EcslAggregatesApiResult> =>
  getRequest(`vFile/ecslEntry/${standardTemplateId}/`, { type, limit, offset });

/**
 * Fetch ECSL/ECPL aggregates totals
 */
export const getEcslEntryTotals = (standardTemplateId: string): Promise<EcslAggregateTotalsApi> =>
  getRequest(`vFile/ecslEntryTotals/${standardTemplateId}/`);
